import React, { useEffect, useMemo, useState } from 'react'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { ProductsWithoutPicturesReportApi } from '../services/productsWithoutPicturesReportApi'
import Swal from 'sweetalert2'
import { IProductsWithoutPicturesReport } from '../models/models'
import Table from '../../../../../components/Table'
import IPSelectBox from '../../../../../components/IPSelectBox'
import { ICompany } from '../../OpportunityAisleProduct/models/opportunityMarketList'
import { ISelectOption } from '../../../HomeAndSiteOperation/BulkAdding/components/BulkAdding'
import { useCustomReducer } from '../../../../../base/customHooks'
import { Link } from 'react-router-dom'
import { exportToXLSX } from '../../../../../base/utils/dataHelper'
import { getCompanyApi } from '../../../components/api'

interface ProductListState {
  companies: ISelectOption[]
  selectedCompany?: ISelectOption,
  muds: ISelectOption[]
  allMuds: ISelectOption[]
  selectedMud?: ISelectOption,
  //selectedStatus?: ISelectOption,
}

function ProductsWithoutPictures(props: BaseComponentWithContextProps) {
  const [pictures, setPictures] = useState<IProductsWithoutPicturesReport[]>([])
  const [allProducts, setAllProducts] = useState<IProductsWithoutPicturesReport[]>([])

  const getInitialState = (): ProductListState => {
    return {
      companies: [],
      muds: [],
      allMuds: [],
      selectedCompany: undefined,
    }
  }

  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<ProductListState>(intialState)

  useEffect(() => {
    getCompanies()
  }, [])

  useEffect(() => {
    if (state.companies.length > 0)
      productsWithoutPicturesReport()
  }, [state.companies])

  useEffect(() => {
    filterProducts()
  }, [state.selectedCompany, state.selectedMud])

  const productsWithoutPicturesReport = async () => {
    props.showLoading()
    const productsWithoutPicturesReportApi: ProductsWithoutPicturesReportApi = new ProductsWithoutPicturesReportApi({})
    await productsWithoutPicturesReportApi
      .productsWithoutPicturesReport()
      .then(async result => {
        if (result) {
          // 1. Benzersiz ProductMd değerlerini al
          const uniqueProductMds = Array.from(new Set(result
            .filter(item => item.ProductMd) // ProductMd alanı olanları filtrele
            .map(item => item.ProductMd)     // Sadece ProductMd alanlarını al
          ));

          // 2. ISelectOption formatına dönüştür
          const productMdOptions = uniqueProductMds
            .filter(md => md) // Son bir kontrol (null/undefined/boş string olmasın)
            .map(md => ({
              label: md as string,
              value: md as string
            }));

          // 3. Verileri kaydet
          setAllProducts(result.sort((a, b) => Number(a.CompanyId) - Number(b.CompanyId)))
          setState({
            allMuds: productMdOptions,
            muds: productMdOptions
          })
          setPictures(result.sort((a, b) => Number(a.CompanyId) - Number(b.CompanyId)))

          props.hideLoading()
        }
      })
      .catch((err: any) => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      }
      )
  }

  const filterProducts = () => {
    let res = allProducts

    if (state.selectedCompany)
      res = res.filter(company => company.CompanyId === state.selectedCompany?.value)

    if (state.selectedMud)
      res = res.filter(company => company.ProductMd === state.selectedMud?.value)

    setPictures(res)
  }

  //#region Excel'e aktarma
  const excelButton = async () => {
    try {
      if (pictures) {
        const data: any[] = []
        if (pictures.length > 0) {
          pictures.map(item => {
            return data.push({
              Şirket: state.companies?.find(company => company.value === item.CompanyId)?.label || '',
              'Kota Kodu': item.QuotaCode,
              'Ürün Müdürü': item.ProductMd,
              'Malzeme Numarası': item.MaterialNumber,
              'Ürün Kodu': item.ProductCode,
              'Ürün Açıklaması': item.ProductName
            })
          })
          exportToXLSX(data, 'Resimleri Eklenmemiş Ürünler Listesi')
        }
      }
    }
    catch (err: any) {
      Swal.fire({
        icon: 'error',
        title: err.description,
        allowOutsideClick: true,
        backdrop: true,
      })
    }
  }
  //#endregion

  const getCompanies = async () => {
    try {
      const companyList: ICompany[] = await getCompanyApi()
      const companiesOptions: ISelectOption[] = companyList.map(company => ({
        label: company.Name,
        value: company.Id,
      }))
      setState({ companies: companiesOptions })
    } catch (err) {
      console.log('Fetch Companies Error:', err)
    }
  }


  // const Status = [
  //   { label: 'Aktif', value: "Aktif" },
  //   { label: 'Pasif', value: "Pasif" },
  // ]

  const tableColumns = useMemo(
    () => [
      {
        Header: 'Sıra',
        accessor: 'col1',
      },
      {
        Header: 'Şirket',
        accessor: 'col2',
      },
      {
        Header: 'Kota Kodu',
        accessor: 'col3',
      },
      {
        Header: 'Ürün Md.',
        accessor: 'col4',
      },
      {
        Header: 'SAP Kodu',
        accessor: 'col5',
      },
      {
        Header: 'Ürün Kodu',
        accessor: 'col6',
      },
      {
        Header: 'Ürün Açıklaması',
        accessor: 'col7',
      },
      // {
      //   Header: 'Durumu',
      //   accessor: 'col8',
      // }
    ],
    []
  )

  const tableData = useMemo(
    () => pictures?.map((item, index) => {
      const data = {
        col1: index + 1,
        col2: state.companies?.find(company => company.value === item.CompanyId)?.label || '',
        col3: item.QuotaCode,
        col4: item.ProductMd,
        col5: item.MaterialNumber,
        col6: <Link
          target="_blank"
          to={`/product/detail/${item.ProductId}?from=productList`}
        >
          {item.ProductCode}
        </Link>,
        col7: item.ProductName,
        //col8: item.Status
      }

      return data
    }), [pictures, state.companies])


  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between align-items-center'>
            <span className='h4'>Resimleri Eklenmemiş Ürünler Listesi</span>
            <div className='d-flex align-items-center'>
              <span>Excel: </span>
              <button
                type='button'
                style={{
                  border: '1px solid #2e7d32',
                  borderRadius: 0,
                  width: '29px',
                  height: '29px',
                  backgroundColor: 'white',
                  margin: '0 10px',
                }}
                onClick={excelButton}
                className='btn text-capitalize background-white-important d-flex align-items-center'
              >
                <i
                  className='fas fa-file-excel'
                  style={{
                    marginLeft: '-6px',
                    fontSize: '18px',
                    color: '#2e7d32',
                  }}
                ></i>
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className='d-flex align-items-end gap-4'>
              <div className='col-lg-2'>
                <label htmlFor='company' className='form-label'>
                  Şirket
                </label>
                <IPSelectBox
                  isClearable
                  id='Şirket'
                  name='Şirket'
                  options={state.companies}
                  value={state.selectedCompany}
                  onChangeSingle={(option) => setState({ selectedCompany: option })}
                />
              </div>
              {/* <div className='col-lg-2'>
                <label htmlFor='company' className='form-label'>
                  Durum
                </label>
                <IPSelectBox
                  isClearable
                  id='Durum'
                  name='Durum'
                  options={Status}
                  value={state.selectedStatus}
                  onChangeSingle={(option) => setState({ selectedStatus: option })}
                />
              </div> */}
              <div className='col-lg-3'>
                <label htmlFor='company' className='form-label'>
                  Ürün Müdürü
                </label>
                <IPSelectBox
                  isClearable
                  id='Mud'
                  name='Mud'
                  options={state.muds}
                  value={state.selectedMud}
                  onChangeSingle={(option) => setState({ selectedMud: option })}
                />
              </div>
            </div>
            <Table columns={tableColumns} data={tableData} currentPage={0} columnCount={7} textAlign={true} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default componentWithContext(ProductsWithoutPictures)